import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card', 'more', 'result'];

  search(event) {
    const query = event.currentTarget.value.trim().toLocaleLowerCase('en-US');
    if (query && !this.searching && this.hasMoreTarget) this.wasOpen = this.moreTarget.open;
    let count = 0;
    this.cardTargets.forEach(card => {
      const visible = card.dataset.state.toLocaleLowerCase('en-US').includes(query);
      card.hidden = !visible;
      if (visible) count++;
    });
    if (this.hasMoreTarget) {
      this.moreTarget.open = query ? true : Boolean(this.wasOpen);
      this.moreTarget.hidden = Boolean(query) && !this.moreTarget.querySelector('[data-state-browser-target="card"]:not([hidden])');
    }
    this.searching = Boolean(query);
    this.resultTarget.hidden = !query;
    this.resultTarget.textContent = count ? `${count} matching state market${count === 1 ? '' : 's'}` : 'No matching state with qualifying data. Try another name or abbreviation.';
  }
}
